<template>
  <ul class="header_social">
    <li v-for="(menu, key) in socialMenus" :key="key">
      <a :href="menu.link" target="_blank" rel="noopener noreferrer">
        <i :class="menu.cssClass"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "TopSocialMenu",
  data() {
    return {
      socialMenus: [
        {
          link: "https://www.facebook.com/profile.php?id=61574302437313",
          cssClass: "fab fa-facebook-f",
        },
        {
          link: "https://www.instagram.com/tijuanarmpizzas/",
          cssClass: "fab fa-instagram",
        },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/menus/TopSocialMenu.vue